import {req} from 'nanoajax.js'

import {AuthStore} from '../auth'

import Actions from './Actions'
import Constants from './Constants'

class OrganizationService {
   constructor() {
      this._locks = {}
   }

   locked(ref) {
      return undefined !== this._locks[ref]
   }

   cachePromise(ref) {
      return this._locks[ref]
   }

   cacheLock(ref, promise) {
      if (this.locked(ref)) {
         return this._locks[ref]
      }

      this._locks[ref] = promise

      return promise
         .then(resp => {
            delete this._locks[ref]

            return resp
         })
         .catch(resp => {
            delete this._locks[ref]
            throw resp
         })
   }

   create(org, data) {
      let payload = JSON.stringify(data),
         url = Constants.ORGANIZATION_URL + '/' + org,
         headers = {
            Authorization:  AuthStore.signV1('POST', url, payload),
            'Content-Type': 'text/json'
         }

      return req.post(url, payload, headers).then(([resp]) => {
         Actions.new(resp)

         return resp
      })
   }

   update(org, data) {
      let payload = JSON.stringify(data),
         url = Constants.ORGANIZATION_URL + '/' + org,
         headers = {
            Authorization:  AuthStore.signV1('PUT', url, payload),
            'Content-Type': 'text/json'
         }

      return req
         .put(url, payload, headers)
         .then(([resp]) => Actions.update(org, resp))
         .catch(err => {
            switch (err.req.status) {
               // bad data in input
               // either user, or organization was not found
               case 400:
               case 404:
                  let txt = 'Server rejected organization update (' + err.req.statusText + ')',
                     newErr = new Error(txt)

                  newErr.req = err.req

                  throw newErr

               default:
                  throw err
            }
         })
   }

   list() {
      const url = Constants.ORGANIZATION_URL,
         headers = {
            Authorization: AuthStore.signV1('GET', url, '')
         }

      if (this.locked(url)) {
         return this.cachePromise(url)
      }

      return this.cacheLock(url, req.get(url, null, headers)).then(([resp]) => Actions.list(resp))
   }

   fetch(org) {
      let url = Constants.ORGANIZATION_URL + '/' + org,
         headers = {
            Authorization: AuthStore.signV1('GET', url, '')
         }

      if (this.locked(url)) {
         return this.cachePromise(url)
      }

      return this.cacheLock(url, req.get(url, null, headers))
         .then(([resp]) => {
            Actions.change(org, resp)

            return resp
         })
         .catch(err => {
            switch (err.req.status) {
               // Access denied, or whatever
               case 400:
               case 403:
                  break

               default:
                  throw err
            }

            return null
         })
   }
}

export default new OrganizationService()



// WEBPACK FOOTER //
// lib/api/organization/Service.js